import { Button, Dialog, DialogActions, DialogContent, MenuItem, TextField } from "@mui/material";
import { Component } from "react";
import DialogTitleWithCloseButton from "../../../components/DialogTitleWithCloseButton";
import { GENDER } from "../../../../../shared/constants";
import { errorToast } from "../../../toast";
import { hideLoading, showLoading } from "../../../loading";
import request from "../../../request";
import swal from "sweetalert";
import MultiSelect from "../../../components/MultiSelect";


export default class Editor extends Component {

   state = {
      gender: '',
      roles: [],
   }

   save = async () => {
      // extract
      const txtName = document.getElementById('txt-name');
      const txtSurname = document.getElementById('txt-surname');
      const txtGender = document.getElementById('txt-gender');
      const txtEmail = document.getElementById('txt-email');

      const name = txtName.value;
      const surname = txtSurname.value;
      const email = txtEmail.value;
      const { gender, roles } = this.state;

      // presence check
      if (!name) {
         errorToast("Name is required");
         return txtName.focus();
      }

      if (!surname) {
         errorToast("Surname is required");
         return txtSurname.focus();
      }

      if (!gender) {
         errorToast("Gender is required");
         return txtGender.focus();
      }

      if (!email) {
         errorToast("Email is required");
         return txtEmail.focus();
      }

      if (roles.length === 0) {
         errorToast("Provide at least one role");
         return;
      }

      // submit
      try {

         showLoading();

         const data = { name, surname, gender, email, roles };
         const res = await request.post('/api/admin/users', data);
         const user = res.data;

         this.props.onClose(user);

      } catch (err) {
         swal("Error", err.toString(), "error");
      } finally {
         hideLoading();
      }
      
   }

   render() {

      return <Dialog open>
         <DialogTitleWithCloseButton onClose={this.props.onClose}>
            Add User
         </DialogTitleWithCloseButton>
         <DialogContent dividers>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
               <TextField
                  id="txt-name"
                  label="Name"
                  size="small"
                  variant="outlined"
                  fullWidth
               />
               <TextField
                  id="txt-surname"
                  label="Surname"
                  size="small"
                  variant="outlined"
                  fullWidth
               />
               <TextField
                  id="txt-gender"
                  label="Gender"
                  size="small"
                  variant="outlined"
                  value={this.state.gender}
                  onChange={e => this.setState({ gender: e.target.value })}
                  select
                  fullWidth
               >
                  {
                     Object
                        .values(GENDER)
                        .map(gender => {
                           return <MenuItem value={gender} key={gender} className="capitalize">
                              {gender}
                           </MenuItem>
                        })
                  }
               </TextField>
               <TextField
                  id="txt-email"
                  label="Email"
                  size="small"
                  variant="outlined"
                  fullWidth
               />
               <MultiSelect
                  id="txt-roles"
                  label="Roles"
                  size="small"
                  value={this.state.roles}
                  onChange={roles => this.setState({ roles })}
                  fullWidth
               >
                  {
                     
                     this.props.allowedRoles.map(role => {
                        return <MenuItem value={role} key={role} className="capitalize">
                           {role.replace(/[-_]/g, ' ')}
                        </MenuItem>
                     })
                  }
               </MultiSelect>
            </div>
         </DialogContent>
         <DialogActions>
            <Button variant="contained" onClick={this.save}>
               SAVE
            </Button>
         </DialogActions>
      </Dialog>
   }
}